import 'babel-polyfill';
import 'unorm';
import React from 'react';
import ReactDOM from 'react-dom';
import {applyMiddleware, compose, createStore} from 'redux';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from "react-redux";
import reducer from "./reducers";
import { createEpicMiddleware } from 'redux-observable';
import thunk from 'redux-thunk';
import { rootEpic } from './network';
import {fontSetup} from "./resources/fontawesome";
import App from "./components/App";
import {DragDropContextProvider} from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import {DexieHooks, hydrate} from "./reducers/persistence";
import {addNotifications, removeNotifications} from "./actions/notifications";
import {ajax} from "rxjs/ajax";
import {codeTables} from "./codes";
import {actionLogger} from "./redux-middleware";
import {notification} from 'antd';
import {version} from "./build.json";
import * as moment from "moment-timezone";

moment.tz.guess(true);

// Poll for updates every sixty seconds
const VERSION_POLL_INTERVAL = 60 * 1000;

fontSetup();

// noinspection JSUnresolvedVariable
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    trace: true,
    maxAge: 100,
    autoPause: true
  })
  : compose;

const epicMiddleware = createEpicMiddleware();
export const reduxLogger = new actionLogger(50);

const store = createStore(
  reducer,
  // preloadedState,
  composeEnhancers(applyMiddleware(thunk, epicMiddleware, reduxLogger.middleware))
);

const hooks = new DexieHooks();
hooks.register('notifications', DexieHooks.CREATED, (dispatch, change) => {
  dispatch(addNotifications([hydrate(change.obj)]));
});
hooks.register('notifications', DexieHooks.UPDATED, (dispatch, change) => {
  dispatch(addNotifications([hydrate(change.mods)]));
});
hooks.register('notifications', DexieHooks.DELETED, (dispatch, change) => {
  dispatch(removeNotifications([change.key]));
});
hooks.run(store);

epicMiddleware.run(rootEpic);

ajax({ url: '/assets/code_tables.json', responseType: 'json'}).toPromise()
  .then((response) => {
    codeTables.setup(response.response);
    ReactDOM.render(
      <DragDropContextProvider backend={HTML5Backend}>
        <Provider store={store}>
          <div>
            <App store={store}/>
          </div>
        </Provider>
      </DragDropContextProvider>
      , document.getElementById('root'));
    registerServiceWorker();
  });

const getVersion = () => ajax({ url: '/build.json' }).toPromise()
  .then(({response = {}} = {}) => {
    if (response.version !== version)
      notification.open({
        message: 'New update available',
        description: <span>An update to cProject is available. Please finish your work and then <a onClick={() => window.location.reload(true)}>click here</a> to refresh.</span>,
        duration: 0,
      });
    else setTimeout(getVersion, VERSION_POLL_INTERVAL);
  })
  .catch(() => setTimeout(getVersion, VERSION_POLL_INTERVAL));

getVersion();



// WEBPACK FOOTER //
// ./src/index.js